import React, { Fragment } from "react";
import { PagedDataView } from "../../../../components/lists/PagedDataView/PagedDataView";
import { IReportQuery, api, Report } from "../../../../logic/api";
import propTypes from "prop-types";
import { renderHeader, renderItem } from "../../helpers/renderers";
import { useTranslation } from "react-i18next";

const ReportBuilderTable: React.FunctionComponent<{
    report?: IReportQuery | Report
}> = (props) => {
    if (props.report == null || (props.report.query || "").length == 0) {
        return <Fragment />
    }

    const { t } = useTranslation();

    return <div style={{ backgroundColor: "white", display: "inline-block" }}>
        <PagedDataView<IReportQuery, unknown>
            apiHook={api.hooks.reports.query}
            parameters={props.report as IReportQuery}
            animate={false}
            maintainRecordsAfterParamChange={true}
            isTable={true}
            showError={true}
            header={renderHeader}
            renderItem={renderItem}
        >
            <div>
                {t("reports.noData")}
            </div>
        </PagedDataView>
    </div>;
}

ReportBuilderTable.propTypes = {
    report: propTypes.any
}
export default ReportBuilderTable;
